import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Code, Moon, Sun, Github, RefreshCw, GitCommit, Clock } from 'lucide-react';

function Header({
  config,
  darkMode,
  toggleTheme,
  handleClearCache,
  lastUpdated,
  formatLastUpdated
}) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <header className="bg-white dark:bg-slate-800 border-b border-slate-200 dark:border-slate-700 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-8 py-6">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-6">
            <h1
              className="text-2xl font-bold flex items-center gap-3 cursor-pointer"
              onClick={() => navigate('/')}
            >
              <Code className="w-7 h-7 text-blue-500" />
              {config.title}
            </h1>
            {config.description && (
              <p className="text-sm text-slate-600 dark:text-slate-400 hidden md:block">
                {config.description}
              </p>
            )}
          </div>

          <div className="flex items-center gap-4">
            {/* Last Updated */}
            {lastUpdated && location.pathname === '/' && (
              <div className="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-400 px-3 py-1.5 bg-slate-100 dark:bg-slate-700 rounded-lg">
                <Clock className="w-4 h-4" />
                <span className="hidden sm:inline">Updated:</span>
                <span className="font-medium">{formatLastUpdated(lastUpdated)}</span>
              </div>
            )}

            {/* Commit History Button */}
            {location.pathname === '/' && (
              <button
                onClick={() => navigate('/commits')}
                className="flex items-center gap-2 px-3 py-1.5 bg-slate-100 dark:bg-slate-700 hover:bg-slate-200 dark:hover:bg-slate-600 rounded-lg transition-colors text-sm font-medium"
                title="View Commit History"
              >
                <GitCommit className="w-4 h-4" />
                <span className="hidden sm:inline">Commits</span>
              </button>
            )}

            <button
              onClick={handleClearCache}
              className="p-2 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors"
              title="Clear Cache & Refresh"
            >
              <RefreshCw className="w-5 h-5" />
            </button>

            <button
              onClick={toggleTheme}
              className="p-2 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors"
              title={darkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
            >
              {darkMode ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
            </button>

            {config.githubUrl && (
              <a
                href={config.githubUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors"
                title="View on GitHub"
              >
                <Github className="w-5 h-5" />
              </a>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
